import axios from './request'
/**
 * 查询可购买状态
 * @param {Array} productIds 产品id列表
 */
export function querystatus(productIds) {
  return axios.post('/bingo/h5/redpacketsale/querystatus', {
    productIds: productIds
  })
}
/**
 * 查询可购买状态
 * @param {number} productId 产品id
 * @param {string} successUrl 支付成功回掉地址
 * @param {string} failureUrl 支付失败回掉地址
 * @param {string} cancelUrl 支付取消回掉地址
 * @param {number} offerPrice 订单金额
 */
export function gobuy(productId, successUrl, failureUrl, cancelUrl, productName, offerPrice) {
  return axios.post('/bingo/h5/redpacketsale/gobuy', arguments[0])
}
